// extracted by mini-css-extract-plugin
module.exports = {"content":"NovedadesConteiner_content__uu9Gr"};